/**
 * Curated list of well-known public relays that are always included in the
 * engagement scan. A wider scan means fewer missed participants — engagement
 * events are often only stored on some relays.
 *
 * The user's own configured read relays are merged in on top of these.
 */
export const DEFAULT_SCAN_RELAYS: string[] = [
  'wss://relay.damus.io',
  'wss://relay.primal.net',
  'wss://nos.lol',
  'wss://relay.nostr.band',
  'wss://relay.ditto.pub',
  'wss://nostr.wine',
  'wss://offchain.pub',
];

/** Normalize a relay URL for deduplication (lowercase, no trailing slash). */
export function normalizeRelayUrl(url: string): string {
  return url.trim().toLowerCase().replace(/\/+$/, '');
}

/**
 * Merge several relay URL lists into one deduplicated list,
 * preserving first-seen order.
 */
export function mergeRelayUrls(...lists: string[][]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const list of lists) {
    for (const url of list) {
      const normalized = normalizeRelayUrl(url);
      if (!normalized || seen.has(normalized)) continue;
      seen.add(normalized);
      out.push(normalized);
    }
  }
  return out;
}
